import { SerializedError } from '@reduxjs/toolkit';

import { KcsSettingsQuery } from '../apis/graphQl/elevio/grappa/types/grappa.types';
import { elevioApi } from '../utils/apis/graphql/api';

type KcsSettingsError = SerializedError | undefined;
type UseKcsSettings = {
  kcsSettingsData: KcsSettingsQuery | undefined;
  kcsSettingsIsFetching: boolean;
  kcsSettingsIsError: boolean;
  kcsSettingsError: KcsSettingsError;
};
export function useKcsSettings(): UseKcsSettings {
  const {
    data: kcsSettingsData,
    isFetching: kcsSettingsIsFetching,
    isError: kcsSettingsIsError,
    error: kcsSettingsError,
  } = elevioApi.grappa.useKcsSettingsQuery({});

  return {
    kcsSettingsData,
    kcsSettingsIsFetching,
    kcsSettingsIsError,
    kcsSettingsError: kcsSettingsError as KcsSettingsError,
  };
}
